<template>
  <div>
    <div class="custom-main">
      <div>检验项目：{{ ITEM_NAME }}</div>
      <div>检验样本：{{ SAMPLE_TYPE }}</div>
      <div>检验医生：{{ NAME }}</div>
      <div>结果查看：</div>
      <table class="table">
        <thead class="thead">
          <tr>
            <th>项目名称</th>
            <th>结果查看</th>
            <th>参考值</th>
            <th>单位</th>
          </tr>
        </thead>
        <tbody>
          <tr style="height: 5px;">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr class="tr" v-for="(item, index) in detailList" :key="index">
            <td>{{ item.DETAIL_NAME }}</td>
            <td class="td-result">
              {{ item.RESULT }}<span>{{ item.FLAG }}</span>
            </td>
            <td>
              {{ item.RANGE }}
            </td>
            <td>{{ item.UNIT }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getLisDetail } from '@/api/api'
import { Toast } from 'vant'

export default {
  data() {
    return {
      detailList: [],
      NAME: '',
      SAMPLE_TYPE: '',
      ITEM_NAME: this.$route.query.ITEM_NAME
    }
  },
  mounted() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true
    })
    getLisDetail({
      patientId: this.$route.query.patientId,
      seqNo: this.$route.query.seqNo
    }).then(res => {
      if (res.code == 200) {
        this.detailList = JSON.parse(res.msg).map(item => {
          switch (item.FLAG) {
            case 'Up':
              item.FLAG = '↑'
              break
            case 'Down':
              item.FLAG = '↓'
              break
            default:
              item.FLAG = ''
              break
          }
          return item
        })
        this.NAME = this.detailList[0].NAME
        this.SAMPLE_TYPE = this.detailList[0].SAMPLE_TYPE
      } else {
        Toast.fail('系统异常')
      }
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.custom-main {
  background: #fff;
  padding: 10px;
}
.custom-main > div {
  margin: 2px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  .til {
    color: #666;
  }
  .text {
    flex: 1;
  }
}
.table {
  margin-top: 10px;
  font-size: 14px;
}
.thead {
  text-align: left;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  background: #c9c8c8;
}
.th td:first-child,
.tr td:first-child {
  width: 40%;
}
.th td:nth-child(3),
.tr td:nth-child(3) {
  width: 30%;
}
.td-result {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
